const axios = require("axios");

var createSinhVien = (payload) => {
	return axios
		.post(`${process.env.VUE_APP_API}${process.env.VUE_APP_SINHVIEN}`, {
			trungTuyenId: payload.trungTuyenId,
			maSinhVien: payload.maSinhVien,
			khoaId: payload.khoaId,
			nganhId: payload.nganhId,
		})
		.then((response) => response)
		.catch((error) => error.response);
};

export const SinhVienService = {
	createSinhVien,
};
